// extracted by mini-css-extract-plugin
export default {"templateDetails":"TemplateDialog-module__templateDetails--LZ0Ei","templateGrid":"TemplateDialog-module__templateGrid--YqEHh"};